/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewPasswordAliases {
  BUTTON_NEW_PASSWORD = 'button-new-password',
  BUTTON_OK = 'button-ok',
  FIELD_CONFIRM_PASSWORD = 'field-confirm-password',
  FIELD_NEW_PASSWORD = 'field-new-password',
  FORM_NEW_PASSWORD = 'form-new-password',
  IMAGE_0 = 'image-0',
  IMAGE_NEW_PASSWORD = 'image-new-password',
  INPUT_CONFIRM_PASSWORD = 'input-confirm-password',
  INPUT_NEW_PASSWORD = 'input-new-password',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_3 = 'layout-3',
  LAYOUT_NEW_PASSWORD = 'layout-new-password',
  LOADER_0 = 'loader-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_HEADER = 'panel-header',
  PANEL_LOADER = 'panel-loader',
  PANEL_SCREEN = 'panel-screen',
  PANEL_SUCCESS = 'panel-success',
  PANEL_TITLE = 'panel-title',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_MESSAGE = 'text-message',
  TEXT_TITLE = 'text-title',
}
export { NewPasswordAliases };
